import { useEffect, useState } from "react";

const usePixelsPerMinute = (
    calendarRef: React.RefObject<HTMLDivElement>,
    viewType: string,
    daysAmount: number,
    timeSlots: string[] | undefined,
) => {
    const [pixelsPerMinute, setPixelsPerMinute] = useState<number | undefined>(undefined);

    useEffect(() => {
        const calculatePixelsPerMinute = () => {
            // Return if no calendar ref current is known
            if (!calendarRef.current) return;

            if (viewType === 'project_planner' && timeSlots) {

                // Get the width of the window of the user
                const windowWidth = window.innerWidth;

                // Get the name column width
                const nameColumnWidth = 300;

                // Determine the number of timeslots per day
                const timeSlotsPerDay = timeSlots.length;

                // Calculate the total width of all calendar columns
                const calendarColumnsWidth = windowWidth - nameColumnWidth;

                // Calculate the width of a single day column
                const dayColumnWidth = calendarColumnsWidth / daysAmount;

                // Calculate the width of a timeslot
                const timeSlotWidth = dayColumnWidth / timeSlotsPerDay;

                // Calculate the width of a minute. Timeslots are 30 minutes.
                const pixelsPerMinute = timeSlotWidth / 30;

                setPixelsPerMinute(pixelsPerMinute);
            }
        }

        calculatePixelsPerMinute();

        window.addEventListener('resize', calculatePixelsPerMinute);

        return () => {
            window.removeEventListener('resize', calculatePixelsPerMinute);
        };
    }, [calendarRef, viewType, daysAmount, timeSlots]);

    return { pixelsPerMinute };
};

export default usePixelsPerMinute;